export default __webpack_public_path__ + "static/media/red-ribbon.55e52e1c.png";